<template>
  <transition name="fade">
    <div class="flex flex-col items-center justify-center absolute w-full h-full pin-y pin-l z-1010 bg-overlay">
      <div class="lg:w-1/3 w-5/6 rounded bg-white relative">
        <div class="absolute pin-t pin-r mr-2 mt-2 cursor-pointer" @click="close">
          <v-icon scale="1" class="self-center" name="times" color="#6f6f70" />
        </div>
        <div class="m-4">
          <h3 class="text-grey-darkest text-sm">Profil</h3>
          <div class="flex flex-col">
            <div class="flex-1 text-grey-darker text-sm mt-4 flex flex-col">
              <div class="flex items-center justify-center mb-8">
                <v-icon name="user-circle" scale="4" class="self-center text-grey-dark" />
              </div>
              <div class="flex flex-row">
                <div class="w-32 font-bold">Nama</div>
                <div>{{ user.name }}</div>
              </div>
              <div class="flex flex-row mt-1">
                <div class="w-32 font-bold">Username</div>
                <div>{{ user.username }}</div>
              </div>
              <div class="flex flex-row mt-1">
                <div class="w-32 font-bold">Role</div>
                <div>{{ role }}</div>
              </div>
              <div v-if="user.role !== 'admin'" class="flex flex-row mt-1">
                <div class="w-32 font-bold">Provinsi</div>
                <div>{{ user.province ? user.province.properties.nama : '' }}</div>
              </div>
              <div v-if="user.role === 'district'" class="flex flex-row mt-1">
                <div class="w-32 font-bold">Kota/Kabupaten</div>
                <div>{{ user.district ? user.district.properties.nama_kabkota : '' }}</div>
              </div>
            </div>
            <div class="text-xs text-grey-darker mt-8" v-if="user.role !== 'admin'">
              Apabila ada pertanyaan atau masukan terkait aplikasi, silakan hubungi:<br>
              <div class="flex flex-col mt-2 font-bold">
                <div>Administrator Nasional</div>
                <div>Email: -</div>
                <div>Telepon: -</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
import {
  TOGGLE_MODAL_PROFILE
} from '@/mutationTypes'

export default {
  name: 'modal-profile',
  computed: {
    ...mapState(['user']),
    role () {
      let role
      switch (this.user.role) {
        case 'admin':
          role = 'Administrator Nasional'
          break
        case 'district':
          role = 'Administrator Kota/Kabupaten'
          break
      }
      return role
    }
  },
  methods: {
    close () {
      this.$store.dispatch(TOGGLE_MODAL_PROFILE, false)
    }
  }
}
</script>
